<template>
  <div style="position: relative">
    <input
      ref="input"
      :value="value"
      type="text"
      class="input-auto-numeric"
      :placeholder="placeholder"
      :disabled="disabled"
      @input="$emit('input', $event.target.value)"
    />
    <span class="input-append">{{ prefix }}</span>
  </div>
</template>

<script>
import AutoNumeric from 'autonumeric'

export default {
  props: {
    value: {
      type: [String, Number],
      default: '',
    },
    placeholder: {
      type: String,
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    prefix: {
      type: String,
      default: '',
    },
    decimalPlaces: {
      type: Number,
      default: 2,
    },
  },
  mounted() {
    new AutoNumeric(this.$refs.input, {
      minimumValue: '0',
      modifyValueOnWheel: false,
      decimalPlaces: this.decimalPlaces,
    })
  },
}
</script>

<style lang="scss" scoped>
.input-auto-numeric {
  text-align: center;
  border-bottom: 1px solid #ccc;
  width: 100%;
  padding-right: 1.5rem;
  &:disabled {
    color: #999999;
  }
  &:focus {
    outline: none;
  }
}
.input-append {
  position: absolute;
  right: 0;
}
</style>
